<template>
  <div class="select-page">
    <div class="select-page__intro">
      <div class="texts">Ваш список понравившихся резиденций</div>
    </div>
    <ApartsList :favorites="true" />
  </div>
</template>

<script>
import ApartsList from "@/components/ApartsList"
export default {
  name: "Aparts",
  components: {
    ApartsList,
    // InteractForm,
  },
  data() {
    return {
      viewType: "list",
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
}
</script>
